import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import ArticlesPanel from "@/components/admin/programNews/ArticlesPanel";
import EventsPanel from "@/components/admin/programNews/EventsPanel";
import RunsPanel from "@/components/admin/programNews/RunsPanel";
import SourcesPanel from "@/components/admin/programNews/SourcesPanel";
import {
  isOpsTab,
  readStoredTab,
  writeStoredTab,
  type OpsTab,
} from "@/components/admin/programNews/opsTab";

const TABS: Array<{ value: OpsTab; label: string }> = [
  { value: "sources", label: "Sources" },
  { value: "articles", label: "Articles" },
  { value: "events", label: "Events" },
  { value: "runs", label: "Runs" },
];

/** Phase 1 operations page: watch the program-news pipeline run, and fix sources. */
const AdminProgramNewsSources = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState<OpsTab>(readStoredTab);

  function handleTabChange(value: string) {
    if (!isOpsTab(value)) return;
    setTab(value);
    writeStoredTab(value);
  }

  return (
    <div className="p-4 max-w-7xl mx-auto space-y-4">
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between gap-4">
            <div>
              <CardTitle>Program News</CardTitle>
              <CardDescription>
                Official athletics news for teams in My Schools: the source registry, the articles
                collected from it, the events the classifier found, and each pipeline run.
              </CardDescription>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate("/recruit-admin/dashboard")}
            >
              Back to Dashboard
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <Tabs value={tab} onValueChange={handleTabChange}>
            <TabsList>
              {TABS.map(({ value, label }) => (
                <TabsTrigger key={value} value={value}>
                  {label}
                </TabsTrigger>
              ))}
            </TabsList>
            <TabsContent value="sources" className="mt-4">
              <SourcesPanel />
            </TabsContent>
            <TabsContent value="articles" className="mt-4">
              <ArticlesPanel />
            </TabsContent>
            <TabsContent value="events" className="mt-4">
              <EventsPanel />
            </TabsContent>
            <TabsContent value="runs" className="mt-4">
              <RunsPanel />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminProgramNewsSources;
